export const QUALIFICATION_TYPES = {
  CLASSX: 1,
  CLASSXII: 2,
  GRADUATION: 3,
  POSTGRADUATION: 4,
  CERTIFICATION: 5
};

export const ADDRESS_TYPES = {
  CURRENT: "current",
  PERMANENT: "permanent"
};
export const CANDIDATE_STATUS = {
  CREATED: { id: 0, description: "Created" },
  INVITED: { id: 1, description: "Invited" },
  INPROGRESS: { id: 2, description: "InProgress" },
  SUBMITTED: { id: 3, description: "Submitted" },
  ONBOARDING: { id: 4, description: "OnBoarding" },
  JOINED: { id: 5, description: "Joined" }
};

export const ROLES = {
  HROPS: 4,
  CANDIDATE: 3,
  RECRUITER: 2,
  ADMIN: 1
};
export const defaultToastOptions = {
  position: "bottom-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

export const RELATIONSHIP = {
  FATHER: { id: 1, description: "Father’s Name" },
  MOTHER: { id: 2, description: "Mother’s Name" },
  HUSBAND: { id: 3, description: "Husband’s Name" }
};

export const defaultRelationShipList = [
  { id: 1, relationShipType: "Father", status: 1 },
  { id: 2, relationShipType: "Mother", status: 1 }
];

export const MARTIAL_TYPES = {
  SINGLE: 1,
  MARRIED: 2
};

export const DECLARATION_PLACES = [
  {
    id: 1,
    name: "Hyderabad"
  },
  {
    id: 2,
    name: "Pune"
  }
];
export const LAPTOP_TYPES = [
  {
    id: 1,
    name: "Mac Book"
  },
  {
    id: 2,
    name: "Windows"
  }
];
export const EMPLOYEE_TYPES = [
  {
    id: 1,
    name: "Permanent"
  },
  {
    id: 2,
    name: "Contractor"
  },
  {
    id: 3,
    name: "Intern"
  }
];
export const ONBOARDING_TYPES = [
  {
    id: 1,
    name: "Office Visit"
  },
  {
    id: 2,
    name: "Virtual"
  }
];

export const CSR_CONTRIBUTION_OPTIONS = [
  {
    id: 0,
    amount: "0"
  },
  {
    id: 1,
    amount: "100"
  },
  {
    id: 2,
    amount: "200"
  },
  {
    id: 3,
    amount: "300"
  },
  {
    id: 4,
    amount: "400"
  },
  {
    id: 5,
    amount: "500"
  },
  {
    id: 6,
    amount: "1000"
  },
  {
    id: 7,
    amount: "1500"
  },
  {
    id: 8,
    amount: "2000"
  },
  {
    id: 9,
    amount: "2500"
  }
];

export const requiredDocuments = [
  {
    id: 1,
    description:
      "All Your Educational Certificates (10th, 12th, Graduation & Post Graduation including provisional certificate and Mark sheet)"
  },
  { id: 2, description: "Copy of PAN Card" },
  { id: 3, description: "Copy of Address Proof" },
  { id: 4, description: "Copy of your photograph" },
  { id: 5, description: "Copy of Aadhaar Card" },
  {
    id: 6,
    description: "Scanned Copy of your passport (If you hold the passport)"
  },
  { id: 7, description: "Last three months pay slips" },
  { id: 8, description: "Latest hike/promotion/offer letter" },
  { id: 9, description: "Copy of last three companies reliving letter" },
  { id: 10, description: "Copy of PF Passbook & History" }
];
export const encryptionKey = "CDKTalentAcquisition@20";

export const onBoardingSteps = {
  PersonalDetailsForm: "Personal Profile",
  ContactDetailsForm: "Contact Details",
  GratuityFormF: "Gratuity Form-F",
  EPFForm2: "EPF Form-2",
  EPFPartB: "EPF Part-B",
  EPFForm11: "EPF Form-11",
  IdentityCardForm: "SEZ Form",
  CSRForm: "CSR",
  BankingInformation: "Banking Info",
  ConfidentialityAgreement: "Confidentiality Agreement"
};

export const fullTimeOrPartTime = [
  { id: 1, description: "Full Time" },
  { id: 0, description: "Part Time" }
];

export const TITLES = [
  { id: 0, description: "Mr" },
  { id: 1, description: "Ms" }
];

export const NATIONALITY = [
  { id: 0, description: "Indian" },
  { id: 1, description: "Foreigner" }
];

export const BLOOD_GROUPS = [
  { id: 0, description: "A +ve" },
  { id: 1, description: "A -ve" },
  { id: 2, description: "B +ve" },
  { id: 3, description: "B -ve" },
  { id: 4, description: "AB +ve" },
  { id: 5, description: "AB -ve" },
  { id: 6, description: "O +ve" },
  { id: 7, description: "O -ve" }
];

export const cropConfig = {
  unit: "%",
  height: 12,
  width: 45,
  x: 5,
  y: 10
};

export const DEFAULT_BANKS = [
  { id: 1, name: "HDFC Bank" },
  { id: 2, name: "ICICI Bank" },
  { id: 3, name: "AXIS Bank" }
];

export const DEFAULT_BANK_IFSC_CODES = [
  { id: 1, code: "HDFC0000545" },
  { id: 2, code: "ICIC0000598" },
  { id: 3, code: "UTIBFFFFFF8" }
];

export const OTHER_OPTION = {
  id: 4,
  text: "Other"
};

export const BANK_LOCATION_OTHER_OPTION = {
  id: 3,
  text: "Other"
};

export const passwordRegex =
  "^(?=.*[A-Z])(?=.*[!@#$%^&*._+=?-])(?=.*[0-9])(?=.*[a-z]).{8,}$";

export const embeddedSpacesPattern = /^((?!\s{2}).)*$/;
export const validUptoPattern = "^[A-Za-z0-9. ]*$";
export const alphaNumericWithSpacePattern = "^[A-Za-z0-9 ]*$";
export const alphabetWithSpacePattern = "^[A-Za-z ]*$";
export const alphaNumericWithSpecialCharacterPattern =
  "^[\\w @#:;&('\")\\-`.+,/,%]*$";
export const mobileNumberPattern = "^([0]|\\+?91[- ]?)?[6789]\\d{9}$";
export const emailIDPattern =
  "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,5}$";
export const panNumberPattern = "^[A-Za-z]{5}\\d{4}[A-Za-z]{1}$";
export const aadharNumberPattern = "^[2-9]{1}[0-9]{3}\\s?[0-9]{4}\\s?[0-9]{4}$";
export const pfUANNumberPattern = "^\\d{12}$";
export const yearPattern = "^\\d{4}$";
export const gradeOrPercentagePattern = "^(100|\\d{1,2}(\\.\\d{0,2})?)%?$";
export const pincodePattern = "^[1-9][0-9]{5}$";
export const positiveNumberPattern = "^[0-9]+$";
export const IFSCCodePattern = "^[A-Z]{4}0[A-Z0-9]{6}$";
export const startingSpacePattern = /^\s/;
export const oneToHundredPattern = /^0*(?:[1-9][0-9]?|100)$/;
export const bioPattern = "^[\\w @#:;&('\")\\-`.+,\/,%]{1,400}$";